import nodon512 from '../../images/nodon512.png'

export  const minImgDefault = nodon512


